import { useHasPermission } from "@/services/auth/AuthContext";
import { useFeatureFlag } from "@/services/features/hook";
import { FeatureFlags } from "@/services/features/types";

/** Role permission withholding Close Won; the deals service enforces it too. */
export const DEALS_CLOSE_WON_DENIED_PERMISSION = "deals.close_won.denied";

/**
 * Whether the current user may close a deal as won. Restricted only when the
 * role carries the denying permission and the rollout flag is on for the
 * tenant; the flag is read from the identified client, so this adds no request.
 * A denied user stays restricted until the flag has loaded.
 */
export const useCanCloseWon = (): boolean => {
  const isCloseWonDenied = useHasPermission(DEALS_CLOSE_WON_DENIED_PERMISSION);
  const { enabled: isRestrictionEnabled, loading: isFlagLoading } =
    useFeatureFlag(FeatureFlags.CRM_9279_ASSIGNMENT_EDIT_RESTRICTIONS);
  return !(isCloseWonDenied && (isFlagLoading || isRestrictionEnabled));
};
